/* ==========================================================================
   ShopyGuru — facets.js (collection & search filtering)
   Loaded only on the templates that need it. Uses helpers exposed by theme.js.
   ========================================================================== */
(() => {
  'use strict';
  const SG = window.ShopyGuru;
  if (!SG) return;
  const { debounce } = SG;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ------------------------------------------------------------------
     Facets: auto-submit, clean URLs, mobile drawer
     ------------------------------------------------------------------ */
  $$('[data-facets-form]').forEach((form) => {
    const go = () => {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => { if (value !== '') params.append(key, value); });
      const base = form.getAttribute('action') || window.location.pathname;
      window.location.href = `${base}?${params.toString()}`;
    };
    const goSoon = debounce(go, 700);
    form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el.matches || !el.matches('[data-facets-autosubmit]') || el.form !== form) return;
      if (el.type === 'number') goSoon(); else go();
    });
  });

  const closeFacets = (panel) => {
    panel.classList.remove('is-open');
    document.body.classList.remove('facets-open');
    const toggle = $(`[aria-controls="${panel.id}"]`);
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  };
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-facets-toggle]');
    if (toggle) {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('facets-open');
      const closeBtn = $('[data-facets-close]', panel);
      if (closeBtn) closeBtn.focus();
      return;
    }
    const closer = e.target.closest('[data-facets-close]');
    if (closer && closer.type !== 'submit') {
      const panel = closer.closest('[data-facets-panel]');
      if (panel) closeFacets(panel);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const panel = $('[data-facets-panel].is-open');
    if (panel) closeFacets(panel);
  });

})();
